import { render, staticRenderFns } from "./NewIndex.vue?vue&type=template&id=4a11ade0&scoped=true&"
import script from "./NewIndex.vue?vue&type=script&lang=js&"
export * from "./NewIndex.vue?vue&type=script&lang=js&"
import style0 from "./NewIndex.vue?vue&type=style&index=0&id=4a11ade0&prod&lang=css&"
import style1 from "./NewIndex.vue?vue&type=style&index=1&id=4a11ade0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a11ade0",
  null
  
)

export default component.exports